/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { SocialRecoveryModule__factory } from "./SocialRecoveryModule__factory";
